<template>
  <section class="section">
    <div class="container items-center">
      <h3 class="section--h3">Parser</h3>
      <p class="section--p">
        Working towards good careers using AI, Analytics and Love
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
section {
  padding: 10rem 10rem 2rem 10rem;
  background: #ffffff;
  position: relative;
}

.truncate {
  width: 80%;
  white-space: normal !important;
  margin-left: 1.5rem;
}

/*===============================================*/
/* MEDIA QUERIES	 						 */
/*===============================================*/

@media (max-width: 1200px) {
  section {
    padding: 10rem 2rem 2rem 2rem;
    background: #ffffff;
  }
  .section__p {
    width: -webkit-fill-available;
    width: -moz-available;
  }
  section {
    padding: 4rem 0rem 2rem 0rem;
  }
}
</style>
